import styled from "styled-components";

import { Box } from "@origin-digital/ods-core";

export const StyledQuestion = styled(Box)`
  && {
    min-height: 420px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
